import { FormEvent, useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dahgoorp14a1h3mr6ma0';

type Status = 'idle' | 'loading' | 'success' | 'error';

const subjects = ['内容更正与反馈', '图集授权与合作', '希望整理某个场次', '订阅与账号问题', '其他事项'];

export default function ContactForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [message, setMessage] = useState('');
  const [count, setCount] = useState(0);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honey = String(payload.get('website_alt') || '').trim();
    if (honey) {
      setStatus('success');
      setMessage('提交成功，感谢你的留言，我们会在一个工作日内查看。');
      form.reset();
      setCount(0);
      return;
    }
    payload.delete('website_alt');

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      if (typeof value === 'string' && value.trim() !== '') body.append(key, value);
    });

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const ok = response.ok && parsed?.code === 'OK';

      if (ok) {
        setStatus('success');
        setMessage('提交成功，感谢你的留言，我们会在一个工作日内查看。');
        form.reset();
        setCount(0);
      } else {
        setStatus('error');
        setMessage(String(serverMsg || '提交失败，请稍后重试。'));
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试。');
    }
  };

  const inputClass =
    'h-11 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400';

  return (
    <form id="contact-inquiry-form" onSubmit={handleSubmit} data-readdy-form className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-2 block text-sm font-medium text-foreground-800">
            称呼 <span className="text-primary-500">*</span>
          </label>
          <input
            id="contact-name"
            type="text"
            name="name"
            required
            placeholder="怎么称呼你"
            className={inputClass}
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="mb-2 block text-sm font-medium text-foreground-800">
            邮箱 <span className="text-primary-500">*</span>
          </label>
          <input
            id="contact-email"
            type="email"
            name="email"
            required
            placeholder="用于接收回复"
            className={inputClass}
          />
        </div>
      </div>

      <div className="mt-5">
        <label htmlFor="contact-subject" className="mb-2 block text-sm font-medium text-foreground-800">
          事项类型
        </label>
        <select id="contact-subject" name="subject" className={`${inputClass} cursor-pointer`}>
          {subjects.map((subject) => (
            <option key={subject} value={subject}>
              {subject}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-5">
        <div className="mb-2 flex items-center justify-between">
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800">
            留言内容 <span className="text-primary-500">*</span>
          </label>
          <span className={`text-xs ${count > 500 ? 'text-primary-600' : 'text-foreground-500'}`}>
            {count}/500
          </span>
        </div>
        <textarea
          id="contact-message"
          name="message"
          required
          rows={6}
          maxLength={500}
          onChange={(event) => setCount(event.target.value.length)}
          placeholder="请尽量写明具体链接或场次，方便我们快速核实"
          className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-3 text-sm leading-relaxed text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        />
      </div>

      <input
        type="text"
        name="website_alt"
        className="form-field-alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="mt-6 flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto sm:px-8"
      >
        <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
        {status === 'loading' ? '提交中...' : '提交留言'}
      </button>

      {message && (
        <p
          role="status"
          className={`mt-4 rounded-md px-3 py-2.5 text-sm ${
            status === 'success'
              ? 'bg-accent-100 text-accent-900'
              : 'bg-primary-100 text-primary-800'
          }`}
        >
          {message}
        </p>
      )}
    </form>
  );
}